import React from 'react';
import classNames from 'classnames';
import BootstrapCol from 'react-bootstrap/Col';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
const Col = ({ children = null, className = null, ...otherProps }) => (
  <BootstrapCol {...otherProps} className={classNames('ws-ui-grid-col', className)}>
    {children}
  </BootstrapCol>
);

export default Col;
